import { TreeNode } from 'primeng/api';

export enum AssetType {
  Templates = 'Templates',
  Images = 'Images',
  Layout = 'Layout',
  DataTables = 'DataTables',
}

export enum AssetActionMenu {
  View = 'view',
  Replace = 'replace',
  Download = 'download',
  Rename = 'rename',
}

export interface DataMaintenanceAssetResponse {
  activeWorktree?: string;
  folders: DataMaintenanceAsset[];
  assets: DataMaintenanceAsset[];
  totalCount: number;
}

export interface DataMaintenanceAsset {
  repositoryKey: string;
  fileName: string;
  productName: string;
  path: string;
  type: string;
  version: string;
  content: DataTableContent<string> | UnknownContent;
  isUserOverride?: boolean;
  fileType?: string;
  lastModified?: string | Date;
  uploadedBy?: string;
  size?: string;
  hasChildren?: boolean;
}

export interface AssetTableRow {
  categoryId?: string;
  repositoryKey: string;
  fileName: string;
  fileType: string;
  lastModified: string;
  uploadedBy: string;
  size: string;
  path?: string;
  isUserOverride?: boolean;
  isFolder?: boolean;
  hasChildren?: boolean;
}

export interface DataTableContent<TKeys extends string = string> {
  tableName: string;
  tableProductName: string;
  tableProductVersion: string;
  tableDefinition: DataMaintenanceTableColumns[];
  data: Array<{ [K in TKeys]: string | number | boolean | null }>;
}

export interface UnknownContent {
  [key: string]: unknown;
}

export interface DataMaintenanceTableColumns {
  name: string;
  header: string;
  type: string;
  unit: string;
  ranges: string | NumericRange;
  format: string;
  referenceCell: string;
  readonly: boolean;
  required: boolean;
  sortable: boolean;
  filterable: boolean;
}

export interface NumericRange {
  min: number;
  max: number;
}

export interface DevOpsCommitResponse {
  branchName: string;
  commitId: string;
  repositoryUrl: string;
  commitUrl: string;
  pullRequestUrl: string;
  repositoryKey: string;
  repositoryDisplayName: string;
  successMessage: string;
}

export interface DevOpsUncommitedCountResponse {
  uncommitedCount: number;
}

export interface ResetWorkspaceResponse {
  deletedCount: number;
  restoredCount: number;
}

export interface WorktreeListResponseDTO {
  worktrees: WorktreeInfo[];
}

export interface WorktreeInfo {
  worktree: string;
  repositoryKey: string | null;
}

export interface WorktreeDeleteCheckResponse {
  canDelete: boolean;
  reason?: string | null;
  blockingPullRequestId?: number | null;
}

export interface AssetConfigResponse {
  assetCategories: Record<string, AssetCategory>;
  repositories: AssetRepository[];
}

export interface AssetRepository {
  repositoryKey: string;
  displayName: string;
  canAccess: boolean;
}

export interface AssetCategory {
  id: string;
  repositoryKey: string;
  displayName: string;
  pathPrefix: string;
  description?: string;
  validationRules: ValidationRules;
}

export interface ValidationRules {
  allowedExtensions: string[];
  maxSizeMB: number;
  allowUpload: boolean;
}
export interface MenuOption {
  label: string;
  icon: string;
  action: () => void;
  enabledWhen?: (node: TreeNode) => boolean;
}

export interface ResolvedMenuOption extends MenuOption {
  disabled: boolean;
}

export interface FileUpload {
  file: File;
  categoryId: string;
  productName: string;
  repositoryKey: string;
  targetFileName?: string;
}

export interface AssetSearchResult {
  path: string;
  fileName: string;
  isFolder: boolean;
}

export interface AssetSearchResponse {
  results: AssetSearchResult[];
  totalCount: number;
}
